import QuestionLabel from '~/components/forms/questions/QuestionLabel';
import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import { FormPart, part } from '~/lib/FormCssApi';

const LocationQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <Autocomplete
                    {...part(FormPart.INPUT)}
                    apiKey={'AIzaSyDjbSiaP0DU0QR8_wygE_QK6JEVdssW8LA'}
                    onChange={e => setValue(e.target.value)}
                    onPlaceSelected={place => setValue(place.formatted_address)}
                    value={value || ''}
                    options={{
                        types: [],
                    }}
                    type="text"
                />
            </div>
        </label>
    );
};

export default LocationQuestion;
